module.exports = __webpack_public_path__ + "img/logo-small-colored.1edeb6e1.svg";